export const makeFontDescriptor = (family, url, weight) => ({
  family,
  url,
  descriptors: {
    weight,
  },
});
